const SCROLL_TO_TOP_EVENT = 'scrollToTop';

export const scrollToTop = () => {
  window.dispatchEvent(new CustomEvent(SCROLL_TO_TOP_EVENT));
  document.querySelector('main')?.scrollTo({ top: 0, behavior: 'smooth' });
};
